import {
  clearAppStateForLocalStorage,
  getDefaultAppState,
} from "@excalidraw/excalidraw/appState";

import type { ExcalidrawElement } from "@excalidraw/element/types";
import type { AppState } from "@excalidraw/excalidraw/types";

import { STORAGE_KEYS } from "../app_constants";
import {
  getActiveWorkFileId,
  getAllWorkFileStorageKeys,
  getWorkFileStorageKeys,
} from "./workfiles";

export const saveUsernameToLocalStorage = (username: string) => {
  try {
    localStorage.setItem(
      STORAGE_KEYS.LOCAL_STORAGE_COLLAB,
      JSON.stringify({ username }),
    );
  } catch (error: any) {
    // Unable to access window.localStorage
    console.error(error);
  }
};

export const importUsernameFromLocalStorage = (): string | null => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_COLLAB);
    if (data) {
      return JSON.parse(data).username;
    }
  } catch (error: any) {
    // Unable to access localStorage
    console.error(error);
  }

  return null;
};

export const importFromLocalStorage = (workFileId = getActiveWorkFileId()) => {
  let savedElements = null;
  let savedState = null;
  const keys = getWorkFileStorageKeys(workFileId);

  try {
    savedElements = localStorage.getItem(keys.elements);
    savedState = localStorage.getItem(keys.appState);
  } catch (error: any) {
    // Unable to access localStorage
    console.error(error);
  }

  let elements: ExcalidrawElement[] = [];
  if (savedElements) {
    try {
      elements = JSON.parse(savedElements);
    } catch (error: any) {
      console.error(error);
      // Do nothing because elements array is already empty
    }
  }

  let appState = null;
  if (savedState) {
    try {
      appState = {
        ...getDefaultAppState(),
        ...clearAppStateForLocalStorage(
          JSON.parse(savedState) as Partial<AppState>,
        ),
      };
    } catch (error: any) {
      console.error(error);
      // Do nothing because appState is already null
    }
  }
  return { elements, appState };
};

export const getElementsStorageSize = (workFileId = getActiveWorkFileId()) => {
  const keys = getWorkFileStorageKeys(workFileId);

  try {
    const elements = localStorage.getItem(keys.elements);
    const elementsSize = elements?.length || 0;
    return elementsSize;
  } catch (error: any) {
    console.error(error);
    return 0;
  }
};

export const getTotalStorageSize = () => {
  try {
    const workFilesStorageSize = getAllWorkFileStorageKeys().reduce(
      (total, keys) => {
        const elements = localStorage.getItem(keys.elements);
        const appState = localStorage.getItem(keys.appState);

        return total + (elements?.length || 0) + (appState?.length || 0);
      },
      0,
    );
    const collab = localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_COLLAB);

    const collabSize = collab?.length || 0;

    return workFilesStorageSize + collabSize;
  } catch (error: any) {
    console.error(error);
    return 0;
  }
};
